// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2iX8A";
var _3 = "seat__container-Ersul";
var _4 = "seat-3Venw";
export { _1 as "__esModule", _2 as "container", _3 as "seat__container", _4 as "seat" }
export default { "__esModule": _1, "container": _2, "seat__container": _3, "seat": _4 }
